/* eslint-disable */
// TODO: Remove previous line and work through linting issues at next edit

module.exports = require('./mnemonic');
